import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Division } from 'types/domainTypes';

interface UserState {
  name: string;
  division: Division;
  email: string;
}

const defaultName = 'user';
const defaultDivision: Division = Division.Kingspan;
const defaultEmail = 'user@email.com';

const initialState: UserState = {
  name: defaultName,
  division: defaultDivision,
  email: defaultEmail,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateName: (state: UserState, action: PayloadAction<string>) => {
      state.name = action.payload ? action.payload : defaultName;
    },
    updateDivision: (state: UserState, action: PayloadAction<Division>) => {
      state.division = action.payload ? action.payload : defaultDivision;
    },
    updateEmail: (state: UserState, action: PayloadAction<string>) => {
      state.email = action.payload ? action.payload : defaultEmail;
    },
  },
});

export const { updateName, updateDivision, updateEmail } = userSlice.actions;

export default userSlice.reducer;
